import { Exclude, Expose, Type } from 'class-transformer';
import { Observable, Subject } from 'rxjs';

import { Default } from '@lib/common/decorators';
import { SnCollection, SnModel } from '@lib/common/models';

import { SnOrganization } from '../organization';
import { SnSharePermissions } from '../share';
import { SnTag } from '../tag';

export class FsRegistry extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public isShared: boolean;

  @Expose()
  public isOwned: boolean;

  @Expose()
  public lon: number;

  @Expose()
  public lat: number;

  @Expose()
  public mou: string;

  @Expose()
  @Type(() => Date)
  public createdTimestamp: Date;

  @Expose()
  @Type(() => Date)
  public updatedTimestamp: Date;

  @Expose()
  public contactName: string;

  @Expose()
  public contactEmail: string;

  @Expose()
  public contactPhone: string;

  @Expose()
  public name: string;

  @Expose()
  public address: string;

  @Expose()
  public city: string;

  @Expose()
  public state: string;

  @Expose()
  public zip: string;

  @Expose()
  public geometry: any;

  @Expose()
  public externalCamera: number;

  @Expose()
  public internalCamera: number;

  @Expose()
  public isQuickRegistry: boolean;

  @Expose()
  public additionalData: any;

  @Expose()
  public media: any[];

  @Expose()
  public meta: any;

  @Expose()
  public publicToken: string;

  @Expose()
  public shareInfo: any;

  @Expose()
  public type: string;

  @Expose()
  @Exclude({ toPlainOnly: true })
  @Type(() => SnOrganization)
  public organization: SnOrganization;

  @Expose()
  @Type(() => SnTag)
  @Default(new SnCollection())
  public tags: SnCollection<SnTag>;

  public fileSize: number = 0;
  public downloadedSize: number = 0;
  public percentDone: number = 0;
  public secondsLeft: number = 0;

  private readonly _cancelDownload$ = new Subject<void>();

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }

  get canEdit(): boolean {
    return !this.isShared || this.shareInfo.permissions === SnSharePermissions.Edit;
  }

  get cancelDownload$(): Observable<void> {
    return this._cancelDownload$.asObservable();
  }
}
